import { IAchievement } from '@/mainComponent/store/interfaces/newInterfaces/IAchievement';
import { IAchievementCounter } from '@/mainComponent/store/interfaces/newInterfaces/IAchievementCounter';
import { IPrizeSpins } from '@/mainComponent/store/interfaces/newInterfaces/IPrizeSpins';
import { IPayment } from '@/mainComponent/store/interfaces/newInterfaces/IPayment';
import { Utils } from '@/utils/Utils';
import { Validator } from '@/utils/ajv/ajv';
import { ACTION } from '@/store/ACTION';
import { PromoComponent } from '@/mainComponent/PromoComponent';

class SetAchievement {
  achievement: any = {};
  prizeSpin: any = {};
  protected isSendZero: boolean = false;

  oldAchievement: any = {
    betOption: 1,
    currencyCode: 'EUR',
    currencyDecimals: 1,
    denomination: 1,
    lines: 1,
    maxBet: 100000000000,
    minBet: 1,
    games: [{ id: 1, name: 'Coin Win' }],
    progress: {
      rounds: {
        total: 1,
        current: 1
      }
    },
    reward: {
      gameName: 'Sunny Coin',
      gid: 1001,
      rounds: 0,
      roundsLeft: null,
      wins: null,
      linkGame: '',
      isAchievementBG: false,
      isAchievementsFSandFR: false,
      inBonusGame: false,
      inFreeSpinGame: false,
      id: null
    },
    time: {
      closedAt: '',
      finishedAt: '',
      finishedTime: '',
      stage: '',
      startedAt: '',
      startedTime: ''
    }
  };

  setRequirements(data: { sendZero: boolean }): void {
    this.isSendZero = data.sendZero;
  }

  setPrize(prize: IPrizeSpins | IPayment): void {
    Validator.validate('prizeSpins', prize);
    switch (prize.type) {
      case 'freeRounds':
        this.setFreeRounds(prize);
        break;
      case 'freeSpins':
        this.setFreeSpins(prize);
        break;
      case 'bonusGame':
        this.setBonusGame(prize);
    }
    this.sendData();
    if (game.store.promo.isMainGameIdle) game.emit(PromoComponent.events.MAIN_FLOW_EXECUTE);
  }

  setFreeRoundsWithoutAchievement(prize: IPrizeSpins, requirements?: any): void {
    game.store.promo.setData({
      freeRounds: {
        rounds: prize.rounds,
        roundsLeft: prize.roundsLeft,
        bet: prize.bet,
        wins: prize.wins,
        sendZero: requirements?.sendZero
      }
    });

    game.emit(PromoComponent.events.SET_WAGER, { id: prize.id, type: 'api' });
  }

  deleteAchievement(promo: IAchievement | IAchievementCounter) {
    game.store.promo.resetAchievement();
    promoApp.eventEmitter.emit(ACTION.CLEAR_ACHIEVEMENT);
  }

  setFreeRounds(freeRounds: IPrizeSpins): void {
    this.setPrizeSpin(freeRounds);
    this.transformFreeRounds();
  }

  setFreeSpins(freeSpins: IPrizeSpins): void {
    this.setPrizeSpin(freeSpins);
    this.transformFreeSpins();
  }

  setBonusGame(bonusGame: IPrizeSpins): void {
    this.setPrizeSpin(bonusGame);
    this.transformBonusGame();
  }

  setPrizeSpin(freeRounds: IPrizeSpins) {
    Utils.parse.call(this, this.prizeSpin, freeRounds);
  }

  transformFreeRounds() {
    this.transformPrizeSpin();
    this.oldAchievement.reward.rounds = this.prizeSpin.rounds;
    this.oldAchievement.reward.roundsLeft = this.prizeSpin.roundsLeft;
    if (this.achievement.type === 'achievementCounter') {
      this.oldAchievement.time.closedAt = this.prizeSpin.time.expiredAt;
    }
  }

  transformFreeSpins() {
    this.transformPrizeSpin();
    this.oldAchievement.reward.rounds = this.prizeSpin.rounds;
    this.oldAchievement.reward.roundsLeft = this.prizeSpin.roundsLeft;
    this.oldAchievement.reward.isAchievementsFSandFR = true;
    if (this.prizeSpin.roundsLeft === 0) this.oldAchievement.reward.inFreeSpinGame = true;
  }

  transformBonusGame() {
    this.transformPrizeSpin();
    this.oldAchievement.reward.rounds = this.prizeSpin.rounds;
    this.oldAchievement.reward.roundsLeft = this.prizeSpin.roundsLeft;
    this.oldAchievement.reward.isAchievementBG = true;
    if (this.prizeSpin.roundsLeft === 0) this.oldAchievement.reward.inBonusGame = true;
  }

  transformPrizeSpin() {
    this.oldAchievement.reward.wins = this.prizeSpin.wins;
    this.oldAchievement.betOption = this.prizeSpin.bet;
    this.oldAchievement.reward.gid = this.prizeSpin.games[0].id;
    this.oldAchievement.reward.gameName = this.prizeSpin.games[0].name;
    this.oldAchievement.reward.linkGame = this.prizeSpin.games[0].link;
    this.oldAchievement.reward.id = this.prizeSpin.id;
  }

  setAchievement(achievement: IAchievementCounter | IAchievement): void {
    const type: string = achievement.type === 'achievement' ? 'achievement' : 'achievementCounter';
    Validator.validate(type, achievement);
    Utils.parse.call(this, this.achievement, achievement);
    this.transformAchievement();
  }

  sendData() {
    game.store.promo.setData({ achievement: this.oldAchievement });
  }

  transformAchievement() {
    this.oldAchievement.currencyCode = this.achievement.currency.code;
    this.oldAchievement.currencyDecimals = this.achievement.currency.decimals;
    this.oldAchievement.minBet = this.achievement.conditions.minBet;
    this.oldAchievement.games = this.achievement.participatingGames;
    this.oldAchievement.progress = {};
    this.oldAchievement.progress[this.achievement.progress[0].type] = {
      total: this.achievement.progress[0].total,
      current: this.achievement.progress[0].current
    };
    // @ts-ignore
    this.oldAchievement.reward.gameName = this.achievement.rewards[0].games[0].name;
    // @ts-ignore
    this.oldAchievement.reward.gid = this.achievement.rewards[0].games[0].id;
    switch (this.achievement.rewards[0].type) {
      case 'freeRounds':
        this.oldAchievement.reward.rounds = this.achievement.rewards[0].amount;
        break;
      case 'bonusGame':
        this.oldAchievement.reward.isAchievementBG = true;
        this.oldAchievement.reward.rounds = 0;
        break;
      case 'freeSpins':
        this.oldAchievement.reward.isAchievementsFSandFR = true;
        this.oldAchievement.reward.rounds = 0;
    }

    // @ts-ignore
    this.oldAchievement.reward.linkGame = this.achievement.rewards[0].games[0].link;
    // this.oldAchievement.reward.id = this.achievement.
    this.oldAchievement.time.finishedTime = this.achievement.time.finishedAt;
    this.oldAchievement.time.finishedAt = this.achievement.time.finishedAt;
    this.oldAchievement.time.startedTime = this.achievement.time.startedAt;
    this.oldAchievement.time.startedAt = this.achievement.time.startedAt;
    this.oldAchievement.time.closedAt = this.prizeSpin?.time?.expiredAt || this.achievement.time.finishedAt;
    this.oldAchievement.time.stage = this.achievement.info.status;
    if (this.achievement.type === 'achievementCounter') {
      this.oldAchievement.rewardsTotal =
        (<IAchievementCounter>this.achievement).info.rewardsTotal * this.oldAchievement.reward.rounds;
      this.oldAchievement.rewardsLeft =
        (<IAchievementCounter>this.achievement).conditions.rewardsLeft * this.oldAchievement.reward.rounds;
    }
    this.oldAchievement.sendZero = this.isSendZero;
    this.sendData();
  }
}

export { SetAchievement };
